import React from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'

import CardCaption from '../CardCaption'

import './usluga-card.sass'

const UslugaCard = ({passport, children, linkOptions}) => {
  const nameTest = linkOptions.map((linkOption) => linkOption.name)
  if (!linkOptions && !passport){
    return null
  }
  if (!children || children.length === 1){
    return (
      linkOptions.map((linkOption) => (
        <Link key={linkOption.key} to={linkOption.path(passport.id)} className="usluga-card">
          <CardCaption iconId={passport.category_id}>
            {passport.name}
          </CardCaption>
          <div className="usluga-card__links">
            <p className="usluga-card__link">{linkOption.name}<span className="right_arrow" /></p>
          </div>
        </Link>
      ))
    )
  } else {
    return (
      <div className="usluga-card">
        <CardCaption iconId={passport.category_id}>
          {passport.name}
        </CardCaption>
        <div className="usluga-card__links">
          {Object.keys(passport && passport.data && passport.data.usluga && passport.data.usluga.schema  || {test:"test"}).length ?
            children
            :
            nameTest[0] === 'Консультация'  ? children : children[1]
          }
        </div>
      </div>
    )
  }
}

{/* eslint-disable */}
UslugaCard.propTypes = {
  linkOptions: PropTypes.array.isRequired,
  passport: PropTypes.object.isRequired
}
{/* eslint-disable */}

export default UslugaCard



// WEBPACK FOOTER //
// ./components/UslugaCard/index.jsx